import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { GetCurrentLocationWithoutPrefix } from 'services/LocationHelper';

export type Location = null | {
	pathname: string;
	search: string;
};

let lastLocation: Location = null;
let currentLocation: Location = null;

type LastLocationProviderProps = RouteComponentProps<any>;

/**
 * Stores changes to the route so that we can get a reference to the previous path and query
 * that the user was on. This is not currently supported by react router out of the box.
 *
 * @class LastLocationProvider
 * @extends {React.Component<LastLocationProviderProps, {}>}
 */
class LastLocationProvider extends React.Component<LastLocationProviderProps, unknown> {
	constructor(props) {
		super(props);

		this.state = {};
	}

	/**
	 * No state is being set, this is just a handy way of updating values after
	 * props change, since componentWillReceiveProps is deprecated.
	 *
	 * @static
	 * @returns
	 * @memberof LastLocationProvider
	 */
	public static getDerivedStateFromProps(props) {
		// skip last location when dealing with culture redirects.
		if (props.location.state && props.location.state.redirectCulture) {
			return null;
		}

		if (currentLocation) {
			lastLocation = currentLocation;
		}

		currentLocation = GetCurrentLocationWithoutPrefix();

		return null;
	}

	public render() {
		return null;
	}
}

export const getLastLocation = (): Location => lastLocation;

export default withRouter(LastLocationProvider);
